import $ from 'jquery';

import widgetFactory from '../../widgetFactory';
import ajaxedForm from '../ajaxedForm';

const widgetName = 'courseEngagement';
const baseClassname = `js-${widgetName}`;

export default widgetFactory(widgetName, {
  options: {},

  _create() {
    this._super(baseClassname);
    this.elements.$formsContainer = this.getWidgetElement('form');

    this._addAjaxedForms();
  },

  _addAjaxedForms() {
    this.element.find('form[data-ajaxed=true]').each((n, element) => {
      ajaxedForm.create(
        {
          onBeforeRequest: function () {
            this._swapForms($(element));
          }.bind(this),
        },
        element
      );
    });
  },

  /**
   * @param {jQuery} $activatedForm
   */
  _swapForms($activatedForm) {
    this.elements.$formsContainer.hide();

    if (this._isUnfollowForm($activatedForm)) {
      this._showAfterUnfollowForm();
    } else {
      this._showNextState($activatedForm);
    }
  },

  /**
   * @param {jQuery} $form
   */
  _isUnfollowForm($form) {
    return $form.parent('.js-courseEngagement-form').is('[data-unfollow=true]');
  },

  _showAfterUnfollowForm() {
    this.elements.$formsContainer.filter('[data-displayedafterunfollow=true]').show();
  },

  /**
   * @param {jQuery} $form
   */
  _showNextState($form) {
    const selector = $form.data('nextstate');
    this.element.find(selector).show();
  },
});
